// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fiTC","content":"styles_content__37uW5","tableWrap":"styles_tableWrap__2Aaqw"};